'use client';

import LiteYouTubeEmbed from 'react-lite-youtube-embed';

export function YouTubeEmbed({ video }: { video: string }) {
  return <LiteYouTubeEmbed id={video} title='YouTube Embed' />;
}
